import React from 'react';
import AnimatedPage from '../components/AnimatedPage';
import { motion } from 'framer-motion';

const variant = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1
  },
}

export default function PageNotFound() {
  return (
    <AnimatedPage>
      <section class="h-100">
        <div className="container h-100">
          <div className="row h-100 py-10 align-items-center">
            <motion.div 
              variants={variant}
              initial="initial"
              animate="animate"
              transition={{ duration: 0.5 }}
              className="col-12"
            >
              <h1 className="display-1 fw-light text-center text-primary">404</h1>
              <p className="display-4 fw-light text-center text-mute">Page not found</p>
            </motion.div>
          </div>
        </div>
      </section>
    </AnimatedPage>
  )
}
